export default __webpack_public_path__ + "static/media/text.d1607a43.svg";